"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = exports.Position = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const clsx_1 = __importDefault(require("clsx"));
const Tooltip_module_css_1 = __importDefault(require("./Tooltip.module.css"));
var Position;
(function (Position) {
    Position[Position["TOP"] = 0] = "TOP";
    Position[Position["LEFT"] = 1] = "LEFT";
})(Position = exports.Position || (exports.Position = {}));
/**
 * Generic tooltip.
 * TODO: mount the tooltip onto the body directly, and calculate position dynamically.
 */
function Tooltip({ message, position, className }) {
    const wrapperClassnames = (0, clsx_1.default)(position === Position.LEFT ? Tooltip_module_css_1.default.leftContainer : Tooltip_module_css_1.default.topContainer, className);
    return ((0, jsx_runtime_1.jsxs)("div", { className: wrapperClassnames, children: [(0, jsx_runtime_1.jsx)("div", { className: position === Position.LEFT ? Tooltip_module_css_1.default.bodyLeft : Tooltip_module_css_1.default.body, children: message }), (0, jsx_runtime_1.jsx)("span", { className: position === Position.LEFT ? Tooltip_module_css_1.default.borderLeft : Tooltip_module_css_1.default.borderTop })] }));
}
exports.Tooltip = Tooltip;
//# sourceMappingURL=Tooltip.js.map